import { post as postProduct } from 'redux/products/actions';
import { createResourceActions } from 'utils/actionsGenerator';

import {
    EDIT_IN_PRODUCT,
    RESET_PRODUCT,
    TOGGLE_CREATE_PRODUCT_DIALOG,
    types,
} from './reducer';

export const { fetch, put } = createResourceActions({
    name: 'product',
    params: { embeds: 'categories,keywords,media' },
    types,
    url: '/products',
});

export const saveProduct = (product) => {
    const action = product.get('id') ? put : postProduct;

    return action(product);
};

export const editInProduct = (path) => (value) => ({
    path,
    type: EDIT_IN_PRODUCT,
    value
});

export const editProduct = (field, value) => editInProduct(['data', field])(value);

export const toggleCreateProductDialog = () => ({ type: TOGGLE_CREATE_PRODUCT_DIALOG });

export const resetProduct = () => ({ type: RESET_PRODUCT });

export const postKeyword = (data) => ({
    payload: {
        request: {
            data,
            method: 'post',
            url: '/keywords',
        },
    },
    types: ['POST_KEYWORD', 'POST_KEYWORD_SUCCESS', 'POST_KEYWORD_FAIL'],
});



// WEBPACK FOOTER //
// ./src/redux/product/actions.js